import { useEffect, useRef } from 'react';
import Slider from 'react-slick';

import { EnergyQuoteType } from '@generated/gql/graphql';
import { useSyncState } from '@hooks/useSyncState';

const sliderSettings = {
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: false,
  variableWidth: false,
  swipeToSlide: false,
  centerMode: false,
  easing: 'ease-out',
  slide: 'div.energy-tariff-modal__breakdown-slider-item',
};

const useBreakdownSlider = () => {
  const [slideIndex, setSlideIndex] = useSyncState('breakdown-slider-slide', 0);
  const [breakdownVariant, setBreakdownVariant] = useSyncState<EnergyQuoteType>(
    'breakdown-slider-variant',
    EnergyQuoteType.Variable
  );
  const sliderRef = useRef<Nullable<Slider>>(null);

  useEffect(() => {
    if (!sliderRef.current) {
      return;
    }

    sliderRef.current.slickGoTo(slideIndex);
  }, [slideIndex, sliderRef]);

  const handleSliderChange = (_: number, next: number) => {
    setSlideIndex(next);
  };

  const handleBreakdownBack = () => {
    setSlideIndex(0);
  };

  const handleBreakdownClick = (variant: EnergyQuoteType) => {
    setBreakdownVariant(variant);
    setSlideIndex(1);
  };

  return {
    breakdownVariant,
    sliderRef,
    sliderSettings,
    handleSliderChange,
    handleBreakdownClick,
    handleBreakdownBack,
  };
};

export { useBreakdownSlider };
